import * as Headless from "@headlessui/react";
import { type LinkProps, Link as TanStackLink } from "@tanstack/react-router";
import type React from "react";
import { forwardRef } from "react";

export type { LinkProps };

export const Link = forwardRef(function Link(
	props: LinkProps & { className?: string },
	ref: React.ForwardedRef<HTMLAnchorElement>,
) {
	return (
		<Headless.DataInteractive>
			<TanStackLink {...props} ref={ref} />
		</Headless.DataInteractive>
	);
});
